import { useContext } from 'react';
import { InspirationPagesContext } from '@/context/InspirationPagesProvider';

export const useInspirationPages = () => {
  const context = useContext(InspirationPagesContext);
  if (!context) {
    throw new Error('useInspirationPages must be used within InspirationPagesProvider');
  }
  return context;
};
